import { Injectable } from "@angular/core";

import { AppConfig } from "src/app/app.config";
import { SiteIds } from "src/app/models/sites";

@Injectable()
export class KiwiSaverGuard  {

    constructor(private appConfig: AppConfig) { }

    public canActivate() {
        var siteId = this.appConfig.appConfigSignal().env.siteId;
        return (siteId && (siteId === SiteIds.INVESTNOW || siteId === SiteIds.EVIDENTIAL));
    }
}
